const adjectives = [
  // Colors
  // Taken from https://github.com/imsky/wordlists/blob/master/adjectives/colors.txt
  'amber',
  'ash',
  'asphalt',
  'auburn',
  'aquamarine',
  'beige',
  'blue',
  'brass',
  'bronze',
  'burgundy',
  'charcoal',
  'cobalt',
  'coffee',
  'crimson',
  'cyan',
  'denim',
  'ecru',
  'emerald',
  'fuchsia',
  'gold',
  'gray',
  'green',
  'heather',
  'indigo',
  'ivory',
  'jet',
  'khaki',
  'lime',
  'magenta',
  'maroon',
  'mint',
  'navy',
  'ochre',
  'olive',
  'orange',
  'pink',
  'plum',
  'purple',
  'red',
  'rust',
  'salmon',
  'silver',
  'snow',
  'steel',
  'tan',
  'teal',
  'violet',

  // Speed (fast and synonyms only)
  // Taken from https://github.com/imsky/wordlists/blob/master/adjectives/speed.txt
  'agile',
  'express',
  'fast',
  'hasty',
  'immediate',
  'instant',
  'nimble',
  'prompt',
  'quick',
  'rapid',
  'speedy',
  'spry',
  'swift',

  // Character (positive/neutral only)
  // Taken from https://github.com/imsky/wordlists/blob/master/adjectives/character.txt
  'adventurous',
  'ambitious',
  'amiable',
  'amicable',
  'bold',
  'brave',
  'bright',
  'calm',
  'careful',
  'cautious',
  'cheerful',
  'clever',
  'creative',
  'curious',
  'daring',
  'eager',
  'elegant',
  'energetic',
  'excited',
  'forgiving',
  'friendly',
  'funny',
  'generous',
  'gentle',
  'graceful',
  'happy',
  'helpful',
  'honest',
  'humane',
  'humble',
  'intense',
  'inventive',
  'kind',
  'lenient',
  'loyal',
  'meek',
  'merry',
  'neat',
  'obliging',
  'patient',
  'pleasant',
  'polite',
  'proper',
  'proud',
  'quick',
  'quiet',
  'refined',
  'relaxed',
  'respectful',
  'serious',
  'silly',
  'simple',
  'smart',
  'soft',
  'sophisticated',
  'strong',
  'stubborn',
  'tender',
  'timid',
  'trusting',
  'wise',
  'witty',

  // Geometry
  // Taken from https://github.com/imsky/wordlists/blob/master/adjectives/geometry.txt
  'acute',
  'adjacent',
  'alternate',
  'central',
  'coincident',
  'collinear',
  'composite',
  'concave',
  'concentric',
  'congruent',
  'convex',
  'coplanar',
  'diagonal',
  'distinct',
  'equidistant',
  'equilateral',
  'fixed',
  'horizontal',
  'inscribed',
  'interior',
  'irregular',
  'linear',
  'oblique',
  'obtuse',
  'parallel',
  'perpendicular',
  'regular',
  'similar',
  'vertical',
];

// famousComputerScientists is exported for tests
export const famousComputerScientists = [
  'wil_van_der_aalst',
  'scott_aaronson',
  'rediet_abebe',
  'hal_abelson',
  'serge_abiteboul',
  'samson_abramsky',
  'leonard_adleman',
  'manindra_agrawal',
  'luis_von_ahn',
  'alfred_aho',
  'frances_e_allen',
  'gene_amdahl',
  'david_p_anderson',
  'lisa_anthony',
  'andrew_appel',
  'cecilia_r_aragon',
  'bruce_arden',
  'sanjeev_arora',
  'winifred_tim_alice_asprey',
  'john_vincent_atanasoff',
  'shakuntala_atre',
  'charles_babbage',
  'charles_bachman',
  'roland_carl_backhouse',
  'john_backus',
  'david_f_bacon',
  'anthony_james_barr',
  'jean_bartik',
  'friedrich_l_bauer',
  'rudolf_bayer',
  'gordon_bell',
  'steven_m_bellovin',
  'cecilia_berdichevsky',
  'tim_berners_lee',
  'daniel_j_bernstein',
  'dines_bjorner',
  'gerrit_blaauw',
  'dorothy_blum',
  'lenore_blum',
  'manuel_blum',
  'barry_boehm',
  'corrado_bohm',
  'jeff_bonwick',
  'grady_booch',
  'george_boole',
  'andrew_booth',
  'kathleen_booth',
  'anita_borg',
  'bert_bos',
  'mikhail_botvinnik',
  'jonathan_bowen',
  'stephen_r_bourne',
  'harry_bouwman',
  'robert_s_boyer',
  'karlheinz_brandenburg',
  'lawrence_m_breed',
  'jack_e_bresenham',
  'sergey_brin',
  'david_j_brown',
  'per_brinch_hansen',
  'sjaak_brinkkemper',
  'fred_brooks',
  'margaret_burnett',
  'michael_butler',
  'tracy_camp',
  'martin_campbell_kelly',
  'bryan_cantrill',
  'luca_cardelli',
  'john_carmack',
  'edwin_catmull',
  'vint_cerf',
  'robert_cailliau',
  'zhou_chaochen',
  'peter_chen',
  'leonardo_chiariglione',
  'tracy_chou',
  'alonzo_church',
  'alberto_ciaramella',
  'edmund_m_clarke',
  'john_cocke',
  'edgar_f_codd',
  'jacques_cohen',
  'ian_coldwater',
  'simon_colton',
  'alain_colmerauer',
  'douglas_comer',
  'paul_justin_compton',
  'gordon_cormack',
  'stephen_cook',
  'james_cooley',
  'danese_cooper',
  'fernando_j_corbato',
  'kit_cosper',
  'patrick_cousot',
  'ingemar_cox',
  'seymour_cray',
  'nello_cristianini',
  'jon_crowcroft',
  'glen_culler',
  'luigi_dadda',
  'ole_johan_dahl',
  'ryan_dahl',
  'andries_van_dam',
  'samir_das',
  'neil_daswani',
  'christopher_j_date',
  'jeff_dean',
  'erik_demaine',
  'richard_demillo',
  'dorothy_e_denning',
  'peter_j_denning',
  'michael_dertouzos',
  'robert_dewar',
  'vinod_dham',
  'jan_dietz',
  'whitfield_diffie',
  'edsger_dijkstra',
  'matthew_dillon',
  'alan_dix',
  'jack_dongarra',
  'marco_dorigo',
  'paul_dourish',
  'charles_stark_draper',
  'susan_dumais',
  'adam_dunkels',
  'jon_michael_dunn',
  'schahram_dustdar',
  'peter_eades',
  'wim_ebbinkhuijsen',
  'john_presper_eckert',
  'alan_edelman',
  'brendan_eich',
  'philip_emeagwali',
  'e_allen_emerson',
  'douglas_engelbart',
  'barbara_engelhardt',
  'andrey_ershov',
  'don_estridge',
  'oren_etzioni',
  'david_c_evans',
  'edward_feigenbaum',
  'edward_felten',
  'tommy_flowers',
  'robert_floyd',
  'sally_floyd',
  'lawrence_j_fogel',
  'mahmoud_samir_fayed',
  'charlotte_froese_fischer',
  'kunihiko_fukushima',
  'richard_p_gabriel',
  'bernard_galler',
  'michael_garey',
  'bill_gates',
  'lisa_gelobter',
  'jeremy_gibbons',
  'juan_e_gilbert',
  'lee_giles',
  'seymour_ginsburg',
  'kurt_godel',
  'e_mark_gold',
  'adele_goldberg',
  'andrew_v_goldberg',
  'ian_goldberg',
  'oded_goldreich',
  'shafi_goldwasser',
  'gene_golub',
  'martin_charles_golumbic',
  'gaston_gonnet',
  'ian_goodfellow',
  'james_gosling',
  'paul_graham',
  'robert_m_graham',
  'susan_l_graham',
  'jim_gray',
  'sheila_greibach',
  'david_gries',
  'ralph_griswold',
  'bill_gropp',
  'tom_gruber',
  'shelia_guberman',
  'ramanathan_v_guha',
  'neil_j_gunther',
  'jurg_gutknecht',
  'michael_guy',
  'robert_griesemer',
  'nico_habermann',
  'philipp_matthaus_hahn',
  'eldon_c_hall',
  'margaret_hamilton',
  'richard_hamming',
  'jiawei_han',
  'frank_harary',
  'juris_hartmanis',
  'johan_hastad',
  'les_hatton',
  'igor_hawryszkiewycz',
  'he_jifeng',
  'eric_hehner',
  'martin_hellman',
  'gernot_heiser',
  'james_hendler',
  'john_l_hennessy',
  'kelsey_hightower',
  'danny_hillis',
  'tin_kam_ho',
  'c_a_r_hoare',
  'louis_hodes',
  'betty_holberton',
  'john_henry_holland',
  'herman_hollerith',
  'gerard_holzmann',
  'john_hopcroft',
  'admiral_grace_hopper',
  'eric_horvitz',
  'paul_hudak',
  'david_a_huffman',
  'john_hughes',
  'roger_hui',
  'watts_humphrey',
  'jean_ichbiah',
  'roberto_ierusalimschy',
  'dan_ingalls',
  'kenneth_e_iverson',
  'ivar_jacobson',
  'cliff_jones',
  'bill_joy',
  'dan_jurafsky',
  'william_kahan',
  'robert_e_kahn',
  'avinash_kak',
  'poul_henning_kamp',
  'richard_karp',
  'narendra_karmarkar',
  'marek_karpinski',
  'ted_kaehler',
  'alan_kay',
  'neeraj_kayal',
  'manolis_kellis',
  'john_george_kemeny',
  'ken_kennedy',
  'brian_kernighan',
  'carl_kesselman',
  'gregor_kiczales',
  'peter_t_kirstein',
  'stephen_cole_kleene',
  'dan_klein',
  'leonard_kleinrock',
  'donald_knuth',
  'andrew_koenig',
  'daphne_koller',
  'michael_kolling',
  'andrey_nikolaevich_kolmogorov',
  'janet_l_kolodner',
  'david_korn',
  'kees_koster',
  'robert_kowalski',
  'john_koza',
  'john_krogstie',
  'joseph_kruskal',
  'thomas_e_kurtz',
  'leslie_lamport',
  'butler_lampson',
  'peter_landin',
  'tom_lane',
  'chris_lattner',
  'charles_e_leiserson',
  'douglas_lenat',
  'rasmus_lerdorf',
  'max_levchin',
  'leonid_levin',
  'kevin_leyton_brown',
  'jochen_liedtke',
  'john_lions',
  'charles_h_lindsey',
  'richard_j_lipton',
  'barbara_liskov',
  'yanhong_annie_liu',
  'darrell_long',
  'patricia_d_lopez',
  'ada_lovelace',
  'david_luckham',
  'nadia_magnenat_thalmann',
  'zohar_manna',
  'james_martin',
  'uncle_bob_c_martin',
  'yuri_matiyasevich',
  'yukihiro_matsumoto',
  'john_mauchly',
  'ujjwal_maulik',
  'derek_mcauley',
  'john_mccarthy',
  'douglas_mcilroy',
  'chris_mckinstry',
  'marshall_kirk_mckusick',
  'lambert_meertens',
  'kurt_mehlhorn',
  'dora_metcalf',
  'bertrand_meyer',
  'silvio_micali',
  'robin_milner',
  'jack_minker',
  'marvin_minsky',
  'james_g_mitchell',
  'arvind_mithal',
  'paul_mockapetris',
  'cleve_moler',
  'faron_moller',
  'john_p_moon',
  'charles_h_moore',
  'edward_f_moore',
  'gordon_moore',
  'j_strother_moore',
  'roger_moore',
  'hans_moravec',
  'carroll_morgan',
  'robert_tappan_morris',
  'joel_moses',
  'rajeev_motwani',
  'oleg_a_mukhanov',
  'stephen_muggleton',
  'klaus_robert_muller',
  'alan_mycroft',
  'brad_a_myers',
  'mm_musharaf_hussain',
  'mihai_nadin',
  'makoto_nagao',
  'frieder_nake',
  'bonnie_nardi',
  'peter_naur',
  'roger_needham',
  'james_g_nell',
  'greg_nelson',
  'bernard_de_neumann',
  'klara_dan_von_neumann',
  'john_von_neumann',
  'allen_newell',
  'max_newman',
  'andrew_ng',
  'nils_john_nilsson',
  'gm_nijssen',
  'tobias_nipkow',
  'maurice_nivat',
  'phiwa_nkambule',
  'jerre_noe',
  'peter_nordin',
  'donald_norman',
  'peter_norvig',
  'george_novacky',
  'kristen_nygaard',
  'martin_odersky',
  'peter_o_hearn',
  't_william_olle',
  'john_osullivan',
  'john_ousterhout',
  'mark_overmars',
  'susan_owicki',
  'larry_page',
  'david_park',
  'david_parnas',
  'dj_patil',
  'yale_patt',
  'david_patterson',
  'mike_paterson',
  'mihai_patrascu',
  'lawrence_paulson',
  'randy_pausch',
  'juan_pavon',
  'judea_pearl',
  'alan_perlis',
  'radia_perlman',
  'pier_giorgio_perotto',
  'rozsa_peter',
  'simon_peyton_jones',
  'kathy_pham',
  'roberto_pieraccini',
  'amir_pnueli',
  'willem_van_der_poel',
  'cicely_popplewell',
  'emil_post',
  'jon_postel',
  'franco_preparata',
  'william_h_press',
  'grzegorz_rozenberg',
  'michael_o_rabin',
  'dragomir_r_radev',
  't_v_raman',
  'brian_randell',
  'anders_p_ravn',
  'raj_reddy',
  'trygve_reenskaug',
  'john_c_reynolds',
  'joyce_k_reynolds',
  'reinder_van_de_riet',
  'bernard_richards',
  'martin_richards',
  'dennis_ritchie',
  'ron_rivest',
  'ken_robinson',
  'colette_rolland',
  'john_romero',
  'douglas_t_ross',
  'guido_van_rossum',
  'm_a_rothman',
  'winston_w_royce',
  'rudy_rucker',
  'steven_rudich',
  'james_rumbaugh',
  'peter_ruzicka',
  'gerard_salton',
  'jean_e_sammet',
  'claude_sammut',
  'carl_sassenrath',
  'mahadev_satyanarayanan',
  'walter_savitch',
  'wilhelm_schickard',
  'jurgen_schmidhuber',
  'steve_schneider',
  'bruce_schneier',
  'fred_b_schneider',
  'sarita_schoenebeck',
  'glenda_schroeder',
  'bernhard_scholkopf',
  'dana_scott',
  'michael_l_scott',
  'robert_sedgewick',
  'ravi_sethi',
  'adi_shamir',
  'claude_shannon',
  'david_e_shaw',
  'cliff_shaw',
  'scott_shenker',
  'ben_shneiderman',
  'edward_h_shortliffe',
  'daniel_siewiorek',
  'joseph_sifakis',
  'herbert_a_simon',
  'munindar_p_singh',
  'ramesh_sitaraman',
  'daniel_sleator',
  'aaron_sloman',
  'arne_solvberg',
  'brian_cantwell_smith',
  'david_canfield_smith',
  'steven_spewak',
  'rohini_kesavan_srihari',
  'sargur_srihari',
  'maciej_stachowiak',
  'richard_stallman',
  'richard_e_stearns',
  'guy_l_steele_jr',
  'thomas_sterling',
  'alexander_stepanov',
  'w_richard_stevens',
  'larry_stockmeyer',
  'salvatore_stolfo',
  'michael_stonebraker',
  'olaf_storaasli',
  'christopher_strachey',
  'volker_strassen',
  'bjarne_stroustrup',
  'madhu_sudan',
  'gerald_jay_sussman',
  'bert_sutherland',
  'ivan_sutherland',
  'latanya_sweeney',
  'mario_szegedy',
  'parisa_tabriz',
  'roberto_tamassia',
  'andrew_s_tanenbaum',
  'austin_tate',
  'bernhard_thalheim',
  'robert_tarjan',
  'mario_tchou',
  'shang_hua_teng',
  'larry_tesler',
  'avie_tevanian',
  'charles_p_thacker',
  'daniel_thalmann',
  'ken_thompson',
  'sebastian_thrun',
  'walter_f_tichy',
  'seinosuke_toda',
  'linus_torvalds',
  'leonardo_torres_y_quevedo',
  'godfried_toussaint',
  'edwin_e_tozer',
  'joseph_f_traub',
  'john_v_tucker',
  'john_tukey',
  'alan_turing',
  'david_turner',
  'murray_turoff',
  'jeffrey_d_ullman',
  'leslie_valiant',
  'vladimir_vapnik',
  'moshe_vardi',
  'francois_vernadat',
  'richard_veryard',
  'sergiy_vilkomir',
  'paul_vitanyi',
  'andrew_viterbi',
  'jeffrey_scott_vitter',
  'paul_vixie',
  'eiiti_wada',
  'david_wagner',
  'manfred_k_warmuth',
  'david_h_d_warren',
  'kevin_warwick',
  'philip_wadler',
  'peter_wegner',
  'joseph_henry_wegstein',
  'peter_j_weinberger',
  'mark_weiser',
  'joseph_weizenbaum',
  'david_wheeler',
  'franklin_h_westervelt',
  'steve_whittaker',
  'jennifer_widom',
  'gio_wiederhold',
  'norbert_wiener',
  'adriaan_van_wijngaarden',
  'mary_allen_wilkes',
  'maurice_vincent_wilkes',
  'yorick_wilks',
  'james_h_wilkinson',
  'sophie_wilson',
  'shmuel_winograd',
  'terry_winograd',
  'patrick_winston',
  'niklaus_wirth',
  'neil_wiseman',
  'dennis_e_wisnosky',
  'stephen_wolfram',
  'mike_woodger',
  'philip_woodward',
  'beatrice_helen_worsley',
  'steve_wozniak',
  'jie_wu',
  'william_wulf',
  'nobuo_yoneda',
  'edward_yourdon',
  'lotfi_zadeh',
  'hans_zantema',
  'arif_zaman',
  'hussein_zedan',
  'shlomo_zilberstein',
  'jill_zimmerman',
  'konrad_zuse',
  'steve_yen',
];

/**
 * generateResourceName generates a random kebab_case name of the form $adjective_$noun
 *
 * This function can be used to pre_fill the `name` of a new resource
 * in order to reduce the amount of time required to fill out a form
 *
 * Note that this function is really only appropriate for resources that aren't
 * required to be globally unique, as there are only ~37,500 possible values
 * (~150 adjectives * ~250 nouns (as of 08/20/21))
 * */
export const generateResourceName = (): string => {
  /* eslint-disable no-bitwise */
  const name = `${adjectives[(adjectives.length * Math.random()) | 0]}${
    famousComputerScientists[(famousComputerScientists.length * Math.random()) | 0]
  }`;
  /* eslint-enable no-bitwise */

  // Added for SURF-3807, we want to remove separators. Ideally, names would be separated
  // by a `-` but this requires escaping when people query. Since no one wants to do the
  // extra work of escaping a query we could use `_` but that character is not allowed for serverless
  // databases. So, we will simplify and remove all separators.
  const re = /_/gi;
  const result = name.replace(re, '');

  // max is 100 for a bucket, but we want to keep them somewhat short.
  if (result.length <= 30) {
    return result;
  }
  return generateResourceName();
};
